define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ProgressBar = (function () {
        function ProgressBar(parent, id) {
            this.parent = parent;
            var newBar = $('<div></div>');
            newBar.attr("id", id);
            parent.append(newBar);
            newBar.kendoProgressBar({
                min: 0,
                max: 1,
                type: "percent",
                change: this.OnChange,
                complete: this.OnComplete
            });
            this.progressBar = newBar.data("kendoProgressBar");
        }
        ProgressBar.prototype.Update = function (value) {
            if (this.progressBar != null)
                this.progressBar.value(value);
        };
        ProgressBar.prototype.OnChange = function (event) {
        };
        ProgressBar.prototype.OnComplete = function (event) {
        };
        return ProgressBar;
    }());
    exports.ProgressBar = ProgressBar;
});
//# sourceMappingURL=ProgressBar.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/ProgressBar.js
// module id = 375
// module chunks = 0